import { AttachDetachStepperModel } from '../../model/attach-detach-step-model';
import { TransportScope } from "src/tmc-yard/common/model/transport.model";
import { TranslationService } from '@sdbn/common';
import { AttachDetachAction } from '../../model/attach-detach-action.enum';
import { AfterViewInit } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { TransportAttachDetachStepperService } from '../../service/transport-attach-detach-stepper.service';
import { ClientStatusService, ConfigurationService } from '@sdbn/appclient';
import { TMCClientParameters } from 'src/tmc-common/tmc-client-parameters';

@Component({
  selector: 'app-select-action',
  templateUrl: './select-action.component.html',
  styleUrls: ['./select-action.component.scss']
})
export class SelectActionComponent implements OnInit, AfterViewInit {

  selectedAction: AttachDetachAction;

  stepperModel: AttachDetachStepperModel;

  actions = AttachDetachAction;

  constructor(
    public translationService: TranslationService,
    private configurationService: ConfigurationService,
    private stepperService: TransportAttachDetachStepperService,
    public clientStatusService: ClientStatusService
  ) {
    this.stepperModel = this.stepperService.stepperModel;
    this.initSelectedAction();

    // hook to enable/disable next button
    this.stepperModel.stepCompleted = () => {
      return this.selectedAction != null;
    };

    this.stepperModel.getNextStepIndex = () => {
      if (this.selectedAction === AttachDetachAction.DETACH_TRUCK) {
        return AttachDetachStepperModel.STEP_DETACH_TRUCK;
      } else if (this.selectedAction === AttachDetachAction.DETACH_TRAILER) {
        return AttachDetachStepperModel.STEP_DETACH_TRAILER;
      } else if (this.selectedAction === AttachDetachAction.DETACH_TRAILER_SEMI_TRAILER_TRUCK) {
        return AttachDetachStepperModel.STEP_DETACH_TRAILER_SEMI_TRAILER_TRUCK;
      } else if (this.selectedAction === AttachDetachAction.DETACH_TRUCK_AND_TRAILER) {
        return AttachDetachStepperModel.STEP_DETACH_TRUCK_AND_TRAILER;
      } else if (this.selectedAction === AttachDetachAction.ATTACH_TRUCK) {
        return AttachDetachStepperModel.STEP_ATTACH_TRUCK;
      } else if (this.selectedAction === AttachDetachAction.ATTACH_TRAILER) {
        return AttachDetachStepperModel.STEP_ATTACH_TRAILER;
      } else if (this.selectedAction === AttachDetachAction.TRAILER_SWAP) {
        return AttachDetachStepperModel.STEP_SELECT_TRAILER_SWAP_TARGET;
      }
      return AttachDetachStepperModel.STEP_SELECT_ACTION;
    };

    this.stepperModel.getPreviousStepIndex = () => {
      return 0;
    };

    this.stepperModel.beforeNextStep = () => {
      if (this.stepperModel.workingData.action !== this.selectedAction) {
        this.stepperModel.resetDetails();
      }
      this.stepperModel.workingData.action = this.selectedAction;
      return true;
    };
  }

  ngOnInit() {
  }

  ngAfterViewInit(): void {
  }

  initSelectedAction() {

    // WUrde bereits eine Action gesetzt wird nicht neu initialisiert
    if (this.stepperModel.workingData.action != null) {
      this.selectedAction = this.stepperModel.workingData.action;
      return;
    }

    if (this.stepperModel.workingData.transportScope !== TransportScope.TRAIN && !this.isAttachTruckDisabled()) {
      this.selectedAction = AttachDetachAction.ATTACH_TRUCK;
    } else {
      if (!this.isDetachTruckDisabled()) {
        this.selectedAction = AttachDetachAction.DETACH_TRUCK;
      } else if (!this.isDetachTruckAndTrailerDisabled()) {
        this.selectedAction = AttachDetachAction.DETACH_TRUCK_AND_TRAILER;
      } else if (!this.isDetachTrailerDisabled()) {
        this.selectedAction = AttachDetachAction.DETACH_TRAILER;
      } else if (!this.isDetachTrailerSemiTrailerTruckDisabled()) {
          this.selectedAction = AttachDetachAction.DETACH_TRAILER_SEMI_TRAILER_TRUCK;
      } else if (!this.isAttachTruckDisabled()) {
        this.selectedAction = AttachDetachAction.ATTACH_TRUCK;
      } else if (!this.isAttachTrailerDisabled()) {
        this.selectedAction = AttachDetachAction.ATTACH_TRAILER;
      }
    }

  }

  isDetachTruckDisabled(): boolean {
    if (!this.stepperModel.workingData) {
      return true;
    }

    if (this.stepperModel.workingData.transportScope === TransportScope.TRAIN) {
      return false;
    }

    return true;
  }

  isDetachTruckAndTrailerDisabled(): boolean {

    if (!this.swapTrailerEnabled()) {
      return true;
    }

    if (!this.stepperModel.workingData) {
      return true;
    }

    if (this.stepperModel.workingData.transportScope === TransportScope.TRAIN) {
      return false;
    }

    return true;
  }

  isDetachTrailerDisabled(): boolean {
    if (!this.swapTrailerEnabled()) {
      return true;
    }

    if (!this.stepperModel.workingData) {
      return true;
    }

    if (this.stepperModel.workingData.transportScope === TransportScope.TRAILER) {
      return false;
    }

    return true;
  }

  isDetachTrailerSemiTrailerTruckDisabled(): boolean {
    if (!this.stepperModel.workingData) {
      return true;
    }

    if (this.stepperModel.workingData.transportScope === TransportScope.SEMI_TRAILER_TRUCK) {
      return false;
    }

    return true;
  }

  isAttachTruckDisabled(): boolean {
    if (!this.stepperModel.workingData) {
      return true;
    }

    if (this.stepperModel.workingData.transportScope === TransportScope.TRAILER) {
      return false;
    }

    if (this.stepperModel.workingData.transportScope === TransportScope.SWAP_TRAILER) {
      return false;
    }

    return true;
  }

  isAttachTrailerDisabled(): boolean {

    if (!this.swapTrailerEnabled()) {
      return true;
    }

    if (!this.stepperModel.workingData) {
      return true;
    }

    if (this.stepperModel.workingData.transportScope === TransportScope.SWAP_TRAILER) {
      return false;
    }

    return true;
  }

  isTrailerSwapDisabled(): boolean {

    if (!this.stepperModel.workingData) {
      return true;
    }

    if (this.stepperModel.workingData.transportScope !== TransportScope.TRAIN) {
      return true;
    }

    return false;
  }

  swapTrailerEnabled() {
    return this.configurationService.isEnabled(TMCClientParameters.P_VISITS_ATTACH_DETACH_SWAP_TRAILER_ENABLED, false);
  }

}
